import { GOVERNMENT_ID_DISPLAY_STRINGS } from 'lib/constants/governmentIds';
import DeviceHandoffOption from 'lib/interfaces/DeviceHandoffOption';
import {
  AcceptedMatchResult,
  AddressAutocompleteMethod,
  GovernmentIdAttribute,
  InputField,
  PhoneNumberInfoMatch,
  PhoneNumberSignal,
  SelfieMatch,
} from 'lib/interfaces/verificationConfig';

export const CONFIRMATION_CODE_LENGTH = 4;

export const NUM_PHOTOS_PER_DOCUMENT_CAPTURE = 3;

// Roughly 3 captures a second
export const MULTIPLE_CAPTURE_DELAY = 500;

/**
 * @deprecated - use verification templates
 */
export const ALL_ACCEPTED_MATCH_RESULTS = new Set(Object.values(AcceptedMatchResult));
/**
 * @deprecated - use verification templates
 */
export const ALL_GOVERNMENT_ID_ATTRIBUTES = new Set(Object.values(GovernmentIdAttribute));
// Should be kept in sync with app/lib/view_state/verification_config/government_id.rb :enabled_id_classes
/**
 * @deprecated - use verification templates
 */
export const ALL_GOVERNMENT_ID_ENABLED_ID_CLASSES = new Set(
  Object.keys(GOVERNMENT_ID_DISPLAY_STRINGS),
);
/**
 * @deprecated - use verification templates
 */
export const ALL_GOVERNMENT_ID_DEVICE_HANDOFF_OPTIONS = new Set(Object.values(DeviceHandoffOption));
/**
 * @deprecated - use verification templates
 */
export const ALL_PHONE_NUMBER_INFO_MATCHES = new Set(Object.values(PhoneNumberInfoMatch));
/**
 * @deprecated - use verification templates
 */
export const ALL_PHONE_NUMBER_SIGNALS = new Set(Object.values(PhoneNumberSignal));
/**
 * @deprecated - use verification templates
 */
export const ALL_SELFIE_MATCHES = new Set(Object.values(SelfieMatch));
/**
 * @deprecated - use verification templates
 */
export const ALL_INPUT_FIELDS = new Set(Object.values(InputField));
/**
 * @deprecated - use verification templates
 */
export const ALL_ADDRESS_AUTOCOMPLETE_METHODS = new Set(Object.values(AddressAutocompleteMethod));

export const VERIFICATION_PAGE_DISPLAY: Record<string, string> = {
  back: 'Back',
  barcode_pdf417: 'Barcode',
  front: 'Front',
  passport_signature: 'Passport Signature',
};
